<template>
  <el-card shadow="hover" class="recommend-card">
    <div class="title-row flex">
      <i v-if="trade.type === Trade.Demand" class="custom-icon icon-demand"/>
      <i v-if="trade.type === Trade.Supply" class="custom-icon icon-supply"/>
      <div class="flex-1 title">
        <el-link class="title-link" @click="handleTitleClick">
          {{trade.title}}
        </el-link>
      </div>
      <div class="date">{{formatDate(new Date(trade.createTime),'yyyy年MM月dd日')}}</div>
    </div>
    <el-row class="image-row" :gutter="10">
      <el-col v-for="(image,index) in trade.tradeAttachmentList" :key="index" :span="50">
        <el-image style="height: 60px" fit="fill" :src="IMAGE_BASE_URL + image.name" :preview-src-list="plainImage"></el-image>
      </el-col>
    </el-row>
    <div class="info-row flex">
      <div class="flex-1">预算:{{formatDecimal(trade.budget)}}元</div>
      <div class="flex-1 text-r"><i class="custom-icon icon-coins"/>已提交意向金{{trade.intention}}元</div>
    </div>
    <div class="tag-row flex">
      <div class="flex-1">
        <i class="custom-icon icon-location"/><span>{{trade.provinceName}}-{{trade.cityName}}-{{trade.townName}}</span>
      </div>
      <div class="flex-1 text-r">
        <span class="tag"><i class="custom-icon icon-eye"/><span>{{trade.readCount}}</span></span>
        <span class="tag"><i class="custom-icon icon-star"/><span>{{trade.collectionCount}}</span></span>
        <span class="tag"><i class="custom-icon icon-link"/><span>{{trade.dockingCount}}</span></span>
      </div>
    </div>
  </el-card>
</template>

<script>
  import { IMAGE_BASE_URL, Trade, Menu } from '../util/constants'
  import {formatDate, formatDecimal} from '../util/common'
  export default {
    name: 'card-trade',
    props: {
      trade: Object
    },
    data() {
      return {
        Trade,
        IMAGE_BASE_URL
      }
    },
    computed: {
        plainImage() {
          let array = []
          this.trade.tradeAttachmentList.forEach(a => {
              if (a.fullName != null) {
                array.push(this.IMAGE_BASE_URL + a.fullName)
              } else {
                array.push(this.IMAGE_BASE_URL + a.name)
              }
          })
          return array
        }
    },
    methods: {
      formatDate,
      formatDecimal,
      handleTitleClick() {
        if (this.trade.type === Trade.Demand) {
          this.$router.push({
            path: `/demand/detail/${this.trade.id}`,
            params: {
              from: Menu.Home
            }
          })
        }
        if (this.trade.type === Trade.Supply) {
          this.$router.push({
            path: `/supply/detail/${this.trade.id}`,
            params: {
              from: Menu.Home
            }
          })
        }
      }
    }
  }
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
  .recommend-card {
    & >>> .el-card__body {
      padding: 10px;
    }

    .title-row {
      align-items: center;
      .title {
        margin: 0 5px;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
        .title-link {
          font-size: 16px;
          font-weight: bold;
          line-height: 30px;
        }
      }
      .date {
        color: #999;
        font-size: 14px;
        white-space: nowrap;
      }
    }

    .image-row {
      margin-top: 10px;
    }

    .info-row {
      margin-top: 10px;
      color: #999;
      font-size: 14px;
      .icon-coins{
        position: relative;
        top: 4px;
        margin-right: 4px;
      }
    }

    .tag-row {
      margin-top: 10px;
      color: #999;
      font-size: 14px;
      .tag {
        margin: 0 4px;
      }
      .icon-eye {
        top: 8px;
        position: relative;
        margin-right: 3px;
      }
      .icon-star {
        top: 4px;
        position: relative;
        margin-right: 3px;
      }
      .icon-link {
        top: 7px;
        position: relative;
        margin-right: 3px
      }
    }

  }
</style>



// WEBPACK FOOTER //
// src/components/card-recommend.vue